import { render, staticRenderFns } from "./PacketStructure.vue?vue&type=template&id=851c20ec&scoped=true&"
import script from "./PacketStructure.vue?vue&type=script&lang=js&"
export * from "./PacketStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851c20ec",
  null
  
)

export default component.exports